import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Button, Form} from "semantic-ui-react";
import TxtLbl from "../../../../../../components/Input/Input/TxtLbl";
import {Col} from "reactstrap";
import * as common from "../../../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axios_event from "../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../axios/axios_api_services";
import * as actionCreator from "../../../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";

class FeedbackQuestions extends React.Component {

  state = {
    question_id: 0,
    question: ''
  };

  componentDidMount() {
    this.setState({
      question_id: this.props.question.event_question_id,
      question: this.props.question.question,
    });
  }

  onChangeQuestion = (e) => {
    let value = e.target.value;
    this.setState({question: value});
  };

  updateQuestion = () => {
    this.state.question === '' ?
      common.notifyMessage("Please enter sub-event name")
      :
      this.updateQuestion_();
  };

  updateQuestion_ = () => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to update this question?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.updateQuestion__();
          break;
        default:
          break;
      }
    });
  }

  updateQuestion__ = () => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    let body = {
      event_question_id: this.state.question_id,
      sub_event_id: this.props.subEventId,
      question: this.state.question,
      type: "RATE_QUESTION"
    };

    axios_event.put(apiConfig.UPDATE_FEED_BACK_QUESTION({corporateId: corporateId})
      , body, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Feedback question updated successfully", 0);
          this.props.closeModal("CLOSE", null);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateQuestion__()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  //toggle
  toggle = () => {
  };

  render() {
    return(
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} centered size="sm">
          <MDBModalHeader className={"title"} toggle={() => this.props.closeModal("CLOSE", null)}>Update Feedback Question</MDBModalHeader>
          <MDBModalBody>
            <Form>

              <Form.Group widths='equal'>
                <TxtLbl
                  tagText={"Question"}
                  placeholder={"Question"}
                  value={this.state.question}
                  onChange={this.onChangeQuestion}
                />
              </Form.Group>

            </Form>

            <div className={'text-right'}>
              <Button
                className="px-5"
                onClick={this.updateQuestion}
              >Update</Button>
            </div>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  current_event: state.eventReducer.current_event,
  current_sub_events: state.eventReducer.current_sub_events,
  current_sub_event_id: state.eventReducer.current_sub_event_id,
  usr_obj: state.userReducer.user,
  event_categories: state.eventReducer.all_Event_Catogaries,
  sponsor_obj: state.notificationReducer.allsponsorobj
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllEventCategories: () => dispatch(actionCreator.callAllEventCatogaries()),
    setCurrentSubEvent: (data) => dispatch(actionCreator.setCurrentSubEvent(data)),
    setCurrentSubEventId: (data) => dispatch(actionCreator.setCurrentSubEventId(data)),
    setCurrentSubEventsData: (data) => dispatch(actionCreator.setCurrentSubEventsData(data)),
    pgChangeHandler: (data) => dispatch(actionCreator.stepActivateionEventHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackQuestions);
